



















import Vue from 'vue'
import Component from 'vue-class-component'
import { State } from 'vuex-class'

import AccountInformationSettings1ServiceAccountSettings from './service-for-account-information-settings/account-information-settings-1-service-account-settings.vue'
import AccountInformationSettings2ActiveAccountSettings from './service-for-account-information-settings/account-information-settings-2-active-account-settings.vue'
import AccountInformationSettings3AccountDescriptionSettings from './service-for-account-information-settings/account-information-settings-3-account-description-settings.vue'


@Component({
  components: {
    AccountInformationSettings1ServiceAccountSettings,
    AccountInformationSettings2ActiveAccountSettings,
    AccountInformationSettings3AccountDescriptionSettings
  }
})
class PersonalInformationResourceItem1AccountInformationSettings extends Vue {
  @State('serviceAccount') serviceAccount?: any
}

export default PersonalInformationResourceItem1AccountInformationSettings


